import React, { useEffect, useRef, useState } from "react";
import ExternalActionsTable from "../../../../components/ExternalActionsTable";
import AgGridTable from "../../../../components/AgGridTable";
import InputForm from "../../../../components/ComponentesFormularios/InputForm";
import AccionesTable from "../../../../components/AccionesTable";
import { ConstantsFormCrud } from "../../../../data/RoutesFormCrud";
import { ModalSide } from "../../../../components/ModalSide";
import Tooltip from "@mui/material/Tooltip";
import { Colors } from "../../../../assets/colors/Colors";
import {
    classResponsiveForm,
    classResponsiveFormWidthHeader,
    classResponsiveFormDoubleWidth,
    classResponsiveFormDoubleWidthHeaderWithoutPaddingX,
    ERRORFIELDREQUIRED,
    optionsEstados,
    optionsEstadosSelect
} from "../../../../data/ConstantForm";
import { FormProvider, useForm, useFormContext, useWatch } from "react-hook-form";
import { generalService } from "../../../../services/apiGenerales";
import { nombrePropio, validArray, validObjectKey, dateToStringFormat, getDateTime, getFechaToCalendarRange, currencyFormatter } from "../../../../util/functions";
import { useDispatch, useSelector } from "react-redux";

import { GlobalConstants } from "../../../../data/GlobalConstants";
import Emitter from "../../../../EventEmitter/EventEmitter";
import { ConstantEventEmitter } from "../../../../data/ConstantEventEmitter";
import { referenciasService } from "../../../../services/apiReferencias";
import { preciosService } from "../../../../services/apiPrecios";

import { modalCRUDService } from "../../../../services/modalCRUDService";
import { alertQuestionService } from "../../../../services/alertQuestionService";
import SelectFormVirtualize from "src/components/ComponentesFormularios/SelectFormVirtualize";
import { CalendarFormRange } from "src/components/ComponentesFormularios/CalendarForm";
import FilterTable from "../../../../components/FilterTable";
import ExcelToJSON from "../../../../components/ExcelToJSON";

const columns = [
    { headerName: 'Acciones', field: "acciones", cellRenderer: "accionesComponent", resizable: true, sortable: false, filter: false, minWidth: 50 },
    { headerName: 'ID', field: "id", resizable: true, sortable: false, filter: false, minWidth: 10, hide: true },
    { headerName: 'ID Nivel', field: "idNivel", resizable: true, sortable: true, filter: true, minWidth: 50  },
    { headerName: 'Nivel', field: "nivel", resizable: true, sortable: true, filter: true, minWidth: 50 },
    { headerName: 'ID Oficina', field: "idOficina", resizable: true, sortable: true, filter: true, minWidth: 40 },
    { headerName: 'Oficina', field: "oficina", resizable: true, sortable: true, filter: true, hide: true, minWidth: 50 },
    { headerName: 'ID Agente', field: "idAgente", resizable: true, sortable: true, filter: true, minWidth: 40 },
    { headerName: 'Agente', field: "agente", resizable: true, sortable: true, filter: true, hide: true, minWidth: 50 },
    { headerName: 'ID Canal', field: "idCanal", resizable: true, sortable: true, filter: true, minWidth: 40 },
    { headerName: 'Canal', field: "canal", resizable: true, sortable: true, filter: true, hide: true, minWidth: 50 },
    { headerName: 'ID Sub Canal', field: "idSubCanal", resizable: true, sortable: true, filter: true, minWidth: 40 },
    { headerName: 'Sub Canal', field: "subCanal", resizable: true, sortable: true, filter: true, hide: true, minWidth: 60 },
    { headerName: 'ID Necesidad', field: "idTipologia", resizable: true, sortable: true, filter: true, minWidth: 40 },
    { headerName: 'Necesidad', field: "tipologia", resizable: true, sortable: true, filter: true, hide: true, minWidth: 60 },
    { headerName: 'ID Producto', field: "idProducto", resizable: true, sortable: true, filter: true, minWidth: 60 },
    { headerName: 'Producto', field: "producto", resizable: true, sortable: true, filter: true,  minWidth: 60 },
    { headerName: 'Precio', field: "precio", resizable: true, sortable: true, filter: true, minWidth: 40, valueFormatter: currencyFormatter, cellClass: 'number-cell' },
    { headerName: 'Válido Desde', field: "dtValidoInicial", resizable: true, sortable: true, filter: true, minWidth: 55 },
    { headerName: 'Válido Hasta', field: "dtValidoFinal", resizable: true, sortable: true, filter: true, minWidth: 55 },
    { headerName: 'Usr Auditor', field: "auditor", resizable: true, sortable: true, filter: true, minWidth: 55 },
    { headerName: 'Fecha Auditoria', field: "fechaAuditoria", resizable: true, sortable: true, filter: true, minWidth: 55 },
];


const AccionesReferencias = ({ params }) => {

    return (
        <AccionesTable deleteAccion={false} params={params} />
    )
}

const FilterSelects = ({ stateSelects, setdataPortafolio, dataTipoNivel, setdataTipoNivel, idUsuario }) => {

    const { handleSubmit, setValue, control, formState: { errors }, getValues } = useFormContext();
    const dispatch = useDispatch();
    //const [dataTipoNivel, setdataTipoNivel] = useState([])
    const [dataOficinaVenta, setdataOficinaVenta] = useState([])
    const [dataAgenteComercial, setdataAgenteComercial] = useState([])
    const [dataCanal, setdataCanal] = useState([])
    const [dataSubCanal, setdataSubCanal] = useState([])
    const [dataTipologia, setDataTipologia] = useState([])


    const nivel = useWatch({
        name: "nivel",
        control
    })

    const getFilteredData = async () => {

        try {
            let res = await preciosService.getSelects(idUsuario);

            const { status, msg, data } = res;

            if (status) {
                setdataTipoNivel(data.tipoNivel[0])
                setdataOficinaVenta(data.oficinaVenta)
                setdataAgenteComercial(data.agenteComercial)
                setdataCanal(data.canal)
                setdataSubCanal(data.subCanal)
                setDataTipologia(data.tipologia)
                setdataPortafolio(data.portafolios)

            } else {
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: msg } });
            }

        } catch (error) {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } });
        }
    }

    useEffect(() => {
        getFilteredData()
    }, [])

    useEffect(() => {
        setValue("oficinaVentas", undefined)
        setValue("agenteComercial", undefined)
        setValue("canal", undefined)
        setValue("subCanal", undefined)
        setValue("tipologia", undefined)

    }, [nivel])

    return (
        <div className="d-flex align-items-center" style={{ width: '100%' }}>

            <SelectFormVirtualize isMulti={false} inputProps={{ control }} disabled={false} identificador="nivel" label="Nivel"
                options={dataTipoNivel} showId={true} multiple={true} required={true} className={`${classResponsiveForm}`}
                customError={null} />

            <SelectFormVirtualize isMulti={false} inputProps={{ control }} disabled={nivel?.nbOficinaVenta != 'true'} showId={true} identificador="oficinaVentas" label="Oficina de Ventas"
                options={dataOficinaVenta} required={true} className={`${classResponsiveForm}`}
                multiple={true}
                customError={null} />

            <SelectFormVirtualize isMulti={false} inputProps={{ control }} disabled={nivel?.nbAgenteComercial != 'true'} showId={true} identificador="agenteComercial" label="Agente comercial"
                options={dataAgenteComercial} required={false} className={`${classResponsiveForm}`}
                multiple={true}
                customError={null} />

            <SelectFormVirtualize isMulti={false} inputProps={{ control }} disabled={nivel?.nbCanal != 'true'} showId={true} identificador="canal" label="Canal"
                options={dataCanal} required={false} className={`${classResponsiveForm}`}
                multiple={true}
                customError={null} />

            <SelectFormVirtualize isMulti={false} inputProps={{ control }} disabled={nivel?.nbSubCanal != 'true'} showId={true} identificador="subCanal" label="SubCanal"
                options={dataSubCanal} required={false} className={`${classResponsiveForm}`}
                multiple={true}
                customError={null} />

            <SelectFormVirtualize isMulti={false} inputProps={{ control }} disabled={nivel?.nbTipologia != 'true' ? true : false} showId={true} identificador="tipologia" label="Tipología"
                options={dataTipologia} required={false} className={`${classResponsiveForm}`}
                multiple={true}
                customError={null} />

        </div>
    )
}

const OtherFilters = ({ dataEstado, dataPortafolio, getFilteredTable }) => {

    const { control, formState: { errors } } = useFormContext();
    const [productos, setproductos] = useState([])
    const dispatch = useDispatch();

    const portafolio = useWatch({
        name: "portafolio",
        control
    })

    const getFilteredProductos = async (portafolio) => {

        try {
            let temp = await preciosService.getProductsByPorfatolio(portafolio.portafolio)
            setproductos(temp.data)

        }
        catch (err) { };

    }

    useEffect(() => {
        getFilteredProductos(portafolio)
    }, [portafolio])

    return (
        <div className="d-flex align-item-center">
            <SelectFormVirtualize isMulti={true} inputProps={{ control }} disabled={false} showId={true} identificador="portafolio" label=" Portafolio de Productos"
                options={dataPortafolio} required={false} className={`${classResponsiveFormWidthHeader}`}
                multiple={true}
                customError={null} />
            <SelectFormVirtualize isMulti={false} inputProps={{ control }} disabled={false} showId={true} identificador="producto" label="Producto"
                options={productos} required={false} className={`${classResponsiveFormWidthHeader}`}
                multiple={true}
                customError={null} />
            <CalendarFormRange inputProps={{ control }} /* disabled={!isEditing} */ identificador="dtVigencia" required={true} label="Fecha Inicio - Fecha Fin"
                 readOnly={true}
                customError={errors.dtVigencia ? ERRORFIELDREQUIRED : null}
                className={`w-20`} />
            <SelectFormVirtualize isMulti={false} inputProps={{ control }} disabled={false} showId={false} identificador="estado" label="Estado"
                options={dataEstado} required={false} className={`${classResponsiveForm}`} multiple={true} customError={null} />

            <Tooltip title="Buscar" aria-label="buscar">
                <a className="icon-container-actions d-flex mx-3 ml-4" onClick={getFilteredTable}>
                    {/* <div style={{ backgroundColor: Colors.COLOR_SKY_THEME }} /> */}
                    <i style={{ color: Colors.COLOR_SKY_THEME }} className="fas fa-search fa-2x" />

                </a>
            </Tooltip>

        </div>
    )
}

const CustomExternalActions = ({ referencia }) => {

    const dispatch = useDispatch();
    const authState = useSelector(state => state.auth)
    const { idUsuario } = authState;
    const cargarExcel = async data => {
        let res = await preciosService.validarCargueExcel(data)

        const { status, data: datos, msg } =  res
        if (status) {

            modalCRUDService.showModal({
                props: {
                    data: res.data,
                    referencia
                },
                type: ConstantsFormCrud.modalTableExcel,
                title: `Tabla Excel`,
                // isAddMode: true,
                // isEditable: true,
                dense: true,
                id: modalCRUDService.defaultId,
                size: `xl`
            });
        }
        else {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: msg } });
        }
    }

    const integridadRegla = async () =>{
        const response = await preciosService.setIntegridad(idUsuario);

        const {status, data: datos, msg} = response;

        if(status){
            modalCRUDService.showModal({
                props: {
                    data: response.data
                },
                type: ConstantsFormCrud.modalTableIntegridad,
                title: `Integridad de fechas en reglas de precios.`,
                dense: true,
                id: modalCRUDService.defaultId,
                size: `xl`
            });
        }else{
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: msg } });
        }
    }

  return (
      <React.Fragment>
            <div className="d-flex align-items-center">
            <ExcelToJSON identificador="fileTest" handleChange={(datos) => cargarExcel(datos[0])} titleTooltip="Carga Masiva"/>
            </div>
            <Tooltip title="Integridad de reglas">

            <a onClick={integridadRegla} className="icon-container-actions d-flex align-items-center">
                <div style={{backgroundColor: '#FFF2C9'}}/>
                <i style={{color: '#FFC000'}} className="far fa-tasks fa-2x"/>
            </a>
          </Tooltip>
      </React.Fragment>
  )
}

const Precios = () => {

    const dispatch = useDispatch();
    const tableRef = useRef(null);

    const [dataTablePrecios, setDataTablePrecios] = useState([]);
    const [dataTipoNivel, setdataTipoNivel] = useState([])
    const [dataPortafolio, setdataPortafolio] = useState([])
    const [dataEstado, setdataEstado] = useState([{ id: 1, text: "Activo" }, { id: 2, text: "Inactivo" }])
    const generalServicesState = useSelector(state => state.generalServices);
    const [columnsDef, setColumnDef] = useState(columns);
    // const methods = useForm();
    const authState = useSelector(state => state.auth)
    const { idUsuario } = authState;
    const isMount = useRef(true);
    const methods = useForm({
        defaultValues: {
            jsPortafoliosComerciales: [],
            jsPortafoliosMateriales: [],
            listTableComerciales: [],
            listTableMateriales: []
        }
    });
    const { control, setValue, handleSubmit, formState: { errors }, register } = methods;

    useEffect(() => {
        setValue('estado', dataEstado[0])
    }, [])

    const nivel = useWatch({
        name: "nivel",
        control
    })

    const oficinaVentas = useWatch({
        name: "oficinaVentas",
        control
    })

    const agenteComercial = useWatch({
        name: "agenteComercial",
        control
    })

    const canal = useWatch({
        name: "canal",
        control
    })

    const subCanal = useWatch({
        name: "subCanal",
        control
    })

    const tipologia = useWatch({
        name: "tipologia",
        control
    })

    const producto = useWatch({
        name: "producto",
        control
    })

    const dtVigencia = useWatch({
        name: "dtVigencia",
        control
    })

    const estado = useWatch({
        name: "estado",
        control
    })

    //Visualizar los 3 estados cuando seleccione un producto
    useEffect(() => {
            if(producto != null || producto != undefined){
                setdataEstado([{ id: 1, text: "Activo" }, { id: 2, text: "Inactivo" }, {id: 3, text: "Sin Estado"}])
            }else {
                setdataEstado([{ id: 1, text: "Activo" }, { id: 2, text: "Inactivo" }])
                setValue('estado', dataEstado[0])
            }
    }, [producto])

    const getFilteredTable = async () => {

        let nivelSelected = nivel != undefined ? nivel?.id : ''
        let oficinaVentasSelected = oficinaVentas != undefined ? oficinaVentas?.id : ''
        let agenteComercialSelected = agenteComercial != undefined ? agenteComercial.id : ''
        let canalSelected = canal != undefined ? canal.id : ''
        let subCanalSelected = subCanal != undefined ? subCanal.id : ''
        let tipologiaSelected = tipologia != undefined ? tipologia.id : ''
        let productoSelected = producto != undefined ? producto.id : ''
        let fechaIni = dtVigencia != undefined ? dateToStringFormat(dtVigencia[0]) : ''
        let fechaFin = dtVigencia != undefined ? dateToStringFormat(dtVigencia[1]) : ''
        if (dtVigencia != undefined) {
            fechaIni = dtVigencia[0] == null ? '' : dateToStringFormat(dtVigencia[0])
            fechaFin = dtVigencia[1] == null ? '' : dateToStringFormat(dtVigencia[1])
        }
        let estadoSelected = estado != undefined ? estado.text : "Activo"

        try {
            let response = await preciosService.getFilteredData({ nivelSelected, oficinaVentasSelected, agenteComercialSelected, canalSelected, subCanalSelected, tipologiaSelected, productoSelected, dtVigencia, fechaIni, fechaFin, estadoSelected }, true)

            const { status, msg, data } = response;

            if (status) {
                if (data) {
                    tableRef.current.api.setRowData(data)
                }
            } else {
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: msg } });
            }
        } catch (error) {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } });
        }

    }

    useEffect(() => {

        (async () => {

            try {

                let temp = await preciosService.getSelects(idUsuario)

                dispatch({
                    type: 'setStateGeneralServices', generalServices: {

                        arrTipoNivel: validArray(temp.data.tipoNivel[0]),
                        arrOficinaVentas: validArray(temp.data.oficinaVenta),
                        arrAgenteComercial: validArray(temp.data.agenteComercial),
                        arrCanal: validArray(temp.data.canal),
                        arrSubCanal: validArray(temp.data.subCanal),
                        arrPortafolio: validArray(temp.data.portafolios),
                        arrTipologia: validArray(temp.data.tipologia)
                    }
                });
            }
            catch (err) { };

        })()

    }, [])

    const handleChangeSwitchTable = ({ checked, name, params, id }) => {

        alertQuestionService.showAlert({
            title: `Cambio de estado #${id}`, question: `¿Estás seguro de cambiar el estado del registro?`,
            message: `Recuerda que al cambiar el estado del registro afectara las gestiones que asocien el registro seleccionado`,
            actionBtnAceptar: () => {

                referenciasService.setStateVehiculoById({ usrAuditoria: idUsuario, estado: checked ? 1 : 0, id }).then(
                    response => {

                        if (isMount.current) {
                            const { status, msg, data } = response;

                            if (status) {
                                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: msg } });

                                const rowNode = params.api.getRowNode(params.node.id);
                                rowNode.setDataValue("estado", checked);
                                alertQuestionService.clear();

                            } else {
                                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: msg } });
                            }
                        }
                    },
                    error => {
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } });
                    }
                )
            },
            actionBtnCancelar: () => alertQuestionService.clear(),
            type: GlobalConstants.alertInfo
        })
    }

    useEffect(() => {
        return () => {
            isMount.current = false;
            Emitter.off(ConstantEventEmitter.eventSwitchTable);
            Emitter.off(ConstantEventEmitter.eventCrudModalTable);
            // Emitter.off(ConstantEventEmitter.eventDeleteTable);
        }
    }, [])

    useEffect(() => {
        Emitter.on(ConstantEventEmitter.eventSwitchTable, ({ name, checked, params }) => handleChangeSwitchTable({ checked, name, params, id: params.node.data.id }));
        Emitter.on(ConstantEventEmitter.eventCrudModalTable, ({ params, type }) => handleOpenModal({ params, type }));
        // Emitter.on(ConstantEventEmitter.eventDeleteTable, ({ params, type }) => handleDeleteRowTable({ params, type }));
    }, [])

    const handleOpenModal = ({ params, type }) => {
        switch (type) {
            case ConstantEventEmitter.keyActionsTableEdit:
                preciosService.getPreciosById(params.node.data.id).then(
                    response => {
                        const { status, msg, data } = response;

                        if (status) {
                            modalCRUDService.showModal({
                                props: { documento: params.node.data.id, data: data, params, tableRef },
                                type: ConstantsFormCrud.modalCRUDPrecios,
                                title: `Editar Precio #${params.node.data.id}`,
                                isAddMode: false,
                                isEditable: true,
                                dense: true,
                                id: modalCRUDService.defaultId,
                                size: `lg`
                            });
                        } else {
                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: msg } });
                        }
                    },
                    error => {
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } });
                    }
                );

                break;
            case ConstantEventEmitter.keyActionsTableView:

                preciosService.getPreciosById(params.node.data.id).then(
                    response => {
                        const { status, msg, data } = response;

                        if (status) {

                            modalCRUDService.showModal({
                                props: { documento: params.node.data.id, data: data, tableRef },
                                type: ConstantsFormCrud.modalCRUDPrecios,
                                title: `Visualizar Precio #${params.node.data.id}`,
                                isAddMode: false,
                                isEditable: false,
                                dense: true,
                                id: modalCRUDService.defaultId,
                                size: `xl`
                            })

                        } else {
                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: msg } });
                        }
                    },
                    error => {
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } });
                    }
                );

                break;
            default:
                if (nivel != undefined && producto != undefined) {
                    let aux = []

                    dataTipoNivel.forEach(el => {
                        if (el.id == nivel?.id) {
                            if ((el.nbAgenteComercial === "true") !== !agenteComercial) {
                                aux[0] = '1'
                            } else {
                                msgAlert('Falta agente')
                                aux[0] = '0'
                            }
                            if ((el.nbCanal === "true") !== !canal) {
                                aux[1] = '1'
                            } else {
                                msgAlert('Falta canal')
                                aux[1] = '0'
                            }
                            if ((el.nbOficinaVenta === "true") !== !oficinaVentas) {
                                aux[2] = '1'
                            } else {
                                msgAlert('Falta oficinaVentas')
                                aux[2] = '0'
                            }
                            if ((el.nbSubCanal === "true") !== !subCanal) {
                                aux[3] = '1'
                            } else {
                                msgAlert('Falta subCanal');
                                aux[3] = '0';
                            }
                            if ((el.nbTipologia === "true") !== !tipologia) {
                                aux[4] = '1'
                            } else {
                                msgAlert('Falta tipologia')
                                aux[4] = '0'
                            }
                        }
                    })

                    if (!aux.find(el => el == '0')) {
                        openModal()
                    }

                } else {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning, message: 'Seleccione una estructura valida y un producto' } });
                }
        }
    }

    const openModal = () => {
        modalCRUDService.showModal({
            props: {
                data: {
                    nivel,
                    oficinaVentas,
                    agenteComercial,
                    canal,
                    subCanal,
                    producto: `${producto?.id}-${producto?.text}`,
                    tipologia
                }, tableRef
            },
            type: ConstantsFormCrud.modalCRUDPrecios,
            title: `Creación de precio`,
            isAddMode: true,
            isEditable: true,
            dense: true,
            id: modalCRUDService.defaultId,
            size: `lg`
        });

        return false;
    }

    const msgAlert = (msg) => {
        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning, message: `Seleccionar ${msg}` } });
    }

    const validateDate = (dateFirst, dateLast) =>{
        if(dateLast < new Date().getTime()){
            return 0; 
        }else if(dateFirst > new Date().getTime() && dateLast > new Date().getTime()){
            return 1;
        }
        return 2
    }


    const onGridReady = (params) => {
        
        const allColumns = [];
        params.columnApi.getAllColumns().map( column =>{
            allColumns.push(column.colId)
        })
        params.columnApi.autoSizeColumns(allColumns, false);
    }

    return (

        <FormProvider {...methods} >
            <div className="content">
                <div className="container-fluid">

                    <div className="mt-1 p-2 bg-white" style={{ border: '1px solid #C6C6C6', borderRadius: 5 }}>

                        <h4>Filtros de Estructura</h4>

                        <hr className="mt-1 p-0" />

                        <div className="row mx-1 align-items-center justify-content-start mt-2">

                            <FilterSelects
                                stateSelects={generalServicesState}
                                setdataPortafolio={setdataPortafolio}
                                dataTipoNivel={dataTipoNivel}
                                setdataTipoNivel={setdataTipoNivel}
                                idUsuario={idUsuario} />
                        </div>
                    </div>

                    <div className="mt-2 p-2 bg-white" style={{ border: '1px solid #C6C6C6', borderRadius: 5 }}>
                        <h4>Otros Filtros</h4>
                        <hr className="mt-1 p-0" />
                        <OtherFilters
                            stateSelects={generalServicesState}
                            dataPortafolio={dataPortafolio}
                            dataEstado={dataEstado}
                            getFilteredTable={getFilteredTable} />
                    </div>

                    <div className="mt-2">

                        <div className="d-flex justify-content-between align-items-center ">

                          <FilterTable tableRef={tableRef} identificador="searchTablePrecios" className="marginY-0" />

                          <ExternalActionsTable
                                accionExcel={{
                                    tableRef,
                                    fileName: "ReglaPrecios",
                                    sheetName: "Hoja1",
                                }}
                                accionVisibilidadColumnas={tableRef}
                                btnCrear={true}
                                // btnExcel={true}
                                downloadTemplate={{
                                  template: "PlantillaReglasPrecios"
                                }}
                                //btnSave={true}
                                accionCrear={handleOpenModal}
                                customActions={<CustomExternalActions referencia={tableRef}/>}
                            />
                        </div>

                        <AgGridTable
                            referencia={tableRef}
                            columnDef={columnsDef}
                            dataList={dataTablePrecios || []}
                            acciones={AccionesReferencias}
                            rowSelection={'multiple'}
                            avatarKey="nombre"
                            onGridReady={onGridReady}
                            getRowStyle={(params) => {
                               
                                const flagEstado = validateDate(Date.parse(params.node.data.dtValidoInicial), Date.parse(params.node.data.dtValidoFinal))
                                if(flagEstado == 0){
                                    return { 'background-color': '#FAEDE6'}
                                }else if(flagEstado == 1){
                                    return { 'background-color': '#D9E1F2'}
                                }
                            }}
                        />
                    </div>

                </div>
                <ModalSide />
            </div>
        </FormProvider>
    )
}

export default Precios;
